import { i18n } from '@shared/i18n';
import _values from 'lodash/values';

class Programs {
  static get values() {
    return {
      academy: 'academy',
      tournament: 'tournament',
      league: 'league',
      camp: 'camp',
      class: 'class',
    };
  }

  static labelOf(programId) {
    if (!this.values[programId]) {
      return programId;
    }

    return i18n(`programs.${programId}.label`);
  }

  static descriptionOf(programId) {
    if (!this.values[programId]) {
      return programId;
    }

    return i18n(`programs.${programId}.description`);
  }

  static get selectOptions() {
    return _values(this.values).map((value) => ({
      id: value,
      value: value,
      title: this.descriptionOf(value),
      label: this.labelOf(value),
    }));
  }
}

export default Programs;
